import { render } from "./EditCreancePage.vue?vue&type=template&id=15e8b38a&ts=true"
import script from "./EditCreancePage.vue?vue&type=script&lang=ts"
export * from "./EditCreancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__